import { withTargetValue } from '@ipfabric/ui-components/utils/events/withTargetValue';
import { TextInput } from 'components/TextInput/TextInput';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

interface Props {
  hasError: boolean;
  onValueChange: (value: string) => void;
  onBlur: () => void;
  value: string;
}

export const DateTimeFilterForNowRule: FC<Props> = (props) => {
  const { advancedFilter: advancedFilterMsg } = useLocale();

  return (
    <div className='flex h-8 items-center gap-4'>
      <TextInput
        hasError={props.hasError}
        value={props.value}
        onChange={withTargetValue(props.onValueChange)}
        onBlur={props.onBlur}
        type='text'
        size='small'
        className='w-14'
      />
      {advancedFilterMsg.dateTimeNowPostfixMessage}
    </div>
  );
};
